import { ReactQuillProps } from 'react-quill';
import { Container, StyledTextEditor } from './AppTextEditor.styled';

const modules = {
    toolbar: ['bold', 'italic', 'underline'],
};

type AppTextEditorProps = Omit<ReactQuillProps, 'theme' | 'modules' | 'formats'> & {
    accessibilityLabel?: string;
};

export const AppTextEditor = ({
    className,
    accessibilityLabel,
    ...restProps
}: AppTextEditorProps) => (
    <Container className={className} aria-label={accessibilityLabel}>
        <StyledTextEditor modules={modules} {...restProps} />
    </Container>
);
